/* ============================================================================
   IFS CUSTOM HERO — assets/custom-hero.js
   Cycles the slides rendered by sections/custom-hero-feature.liquid.
   Dots, chevrons, autoplay (paused on hover/focus, off for reduced motion).
   ========================================================================== */
(function () {
  function init(root) {
    var slides = root.querySelectorAll('.ifh-hero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('.ifh-hero__dot');
    var prev = root.querySelector('[data-ifh-prev]');
    var next = root.querySelector('[data-ifh-next]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 8000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function show(i) {
      current = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('is-active', s === current);
        slides[s].setAttribute('aria-hidden', s === current ? 'false' : 'true');
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === current);
        dots[d].setAttribute('aria-current', d === current ? 'true' : 'false');
      }
    }
    function start() {
      if (reduce || timer) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { show(idx); restart(); });
      })(d);
    }
    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  function boot() {
    var roots = document.querySelectorAll('.ifh-hero');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].hasAttribute('data-ifh-ready')) {
        roots[i].setAttribute('data-ifh-ready', '');
        init(roots[i]);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
